module.exports = __webpack_public_path__ + "img/rav4-19.a2597eed.png";